module.exports = __webpack_public_path__ + "img/huge-icon-file.90a512e3.svg";